import { render, staticRenderFns } from "./asignar_cupo.vue?vue&type=template&id=da871046"
import script from "./asignar_cupo.vue?vue&type=script&lang=js"
export * from "./asignar_cupo.vue?vue&type=script&lang=js"
import style0 from "./asignar_cupo.vue?vue&type=style&index=0&id=da871046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports